import { GET_USER_LIST_ACTION_TYPE, ADD_UPDATE_USER_ACTION_TYPE, GET_USER_DETAILS_ACTION_TYPE, DELETE_USER_ACTION_TYPE } from "../../utils/constants"


const initialState = [];

function userReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_USER_LIST_ACTION_TYPE:
      return [...state, payload];
    case ADD_UPDATE_USER_ACTION_TYPE:
      return [...state, payload];
    case GET_USER_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case DELETE_USER_ACTION_TYPE:
      return [...state, payload];
    
    default:
      return state;
  }
};

export default userReducer;